'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'star-sharp';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e28b';
var svgPathData = 'M278.9 16.7C275.7 6.8 266.5 0 256 0s-19.7 6.8-22.9 16.7L182.5 176 24 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L140.1 320.7 89.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L256 406.4 385.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L371.9 320.7 502.7 218.9c8.1-6.3 11.3-17 8-26.7S498.3 176 488 176l-158.5 0-50.7-159.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarSharp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;